import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import AppLayout from "../layout/AppLayout";
import AccessDeniedState from "./AccessDeniedState";

const TecnicoRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== "TECNICO") {
    return (
      <AppLayout>
        <AccessDeniedState description="Este painel é exclusivo do perfil Técnico." />
      </AppLayout>
    );
  }

  return <AppLayout>{children}</AppLayout>;
};

export default TecnicoRoute;

